import { render } from "./acLoader.vue?vue&type=template&id=0278b0f4&scoped=true"
import script from "./acLoader.vue?vue&type=script&lang=js"
export * from "./acLoader.vue?vue&type=script&lang=js"

import "./acLoader.vue?vue&type=style&index=0&id=0278b0f4&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0278b0f4"]])

export default __exports__